import { createContext } from "react";

const BaseContext = createContext()

export const Provider = BaseContext.Provider

export const Consumer = BaseContext.Consumer


export default  BaseContext;